import axiosInstance from "../../axiosInstance";

// const base = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
// const BASE_URL = `${base}/departments`;

const BASE_URL = "/hrm/departments";

// ⚙️ Hàm xử lý lỗi chung
const handleError = (fnName, error) => {
  console.error(`Lỗi ${fnName}:`, error?.response || error);
  throw error;
};

// ======================================================
// 📘 Lấy tất cả bộ phận (dùng cho dropdown, list, filter)
// ======================================================
export const getAllDepartments = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/all`);
    return res.data;
  } catch (error) {
    handleError("getAllDepartments", error);
  }
};

// ======================================================
// 📘 Lấy danh sách bộ phận theo chi nhánh
// ======================================================
export const getDepartmentsByBranch = async (branchId) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}`, {
      params: { branch_id: branchId },
    });
    return res.data;
  } catch (error) {
    handleError("getDepartmentsByBranch", error);
  }
};

// ======================================================
// 📘 Lấy chi tiết 1 bộ phận theo ID
// ======================================================
export const getDepartmentById = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    handleError("getDepartmentById", error);
  }
};

// ======================================================
// ➕ Tạo mới bộ phận
// ======================================================
export const createDepartment = async (data) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}`, data);
    return res.data;
  } catch (error) {
    handleError("createDepartment", error);
  }
};

// ======================================================
// ✏️ Cập nhật thông tin bộ phận
// ======================================================
export const updateDepartment = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return res.data;
  } catch (error) {
    handleError("updateDepartment", error);
  }
};

// ======================================================
// ❌ Xóa bộ phận
// ======================================================
export const deleteDepartment = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    handleError("deleteDepartment", error);
  }
};
